/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import * as React from 'react'
import { useCallback } from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import NotificationBadge from '../../../common/NotificationBadge'
import './Card.scss'

interface CardProps {
	title: string
	description: string
	img: string
	setFormat: () => void
	active?: boolean
	alpha?: boolean
	beta?: boolean
}

const Card = ({ title, description, img, setFormat, active, alpha, beta }: CardProps) => {
	const handleClick = useCallback(
		(event: React.MouseEvent<HTMLButtonElement>) => {
			setFormat()
			event.preventDefault()
		},
		[setFormat],
	)

	return (
		<button
			role="button"
			className={['ad-format-card', active && 'ad-format-card--active'].filter(Boolean).join(' ')}
			onClick={handleClick}
		>
			<div className="ad-format-card__title">
				{title}
				{(alpha || beta) && (
					<>
						&nbsp;
						<NotificationBadge>
							{alpha && 'ALPHA'}
							{beta && 'BETA'}
						</NotificationBadge>
					</>
				)}
			</div>
			<Row className="ad-format-card__content">
				<Col className="ad-format-card__description" xs={6}>
					{description}
				</Col>
				<Col className="ad-format-card__image" xs={6}>
					<Image src={img} draggable={false} />
				</Col>
			</Row>
		</button>
	)
}

export default Card
